const globalObject = {
  // url: 'https://eurocoin.websganadoras.net',
  url: 'https://backoffice.eurocoinbroker.com'
};

export default globalObject;